import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import qs from "query-string";
import { useLocation } from "react-router-dom";
export var useContactStrategy = function useContactStrategy() {
  var location = useLocation();
  var retailerToken = getRetailerToken();
  var brandToken = getBrandToken();
  var isUserLoggedIn = function isUserLoggedIn() {
    return !!retailerToken || !!brandToken;
  };
  var locationSearch = function locationSearch() {
    var _location$search;
    return qs.parse((_location$search = location === null || location === void 0 ? void 0 : location.search) !== null && _location$search !== void 0 ? _location$search : "");
  };
  var isLoggedOutExperience = function isLoggedOutExperience() {
    return !!locationSearch().loggedOut;
  };
  var shouldShowContactModal = function shouldShowContactModal() {
    return !!locationSearch().contact;
  };
  return {
    isUserLoggedIn: isUserLoggedIn,
    isLoggedOutExperience: isLoggedOutExperience,
    shouldShowContactModal: shouldShowContactModal
  };
};